<template>
    <div class="card-content has-text-centered">
        <p
            class="is-flex is-align-items-center has-text-weight-semibold is-justify-content-center"
        >
            <i
                class="material-icons mr-2"
                v-bind:class="{
                    'has-text-income': trending === 'trending_up',
                    'has-text-outcome': trending === 'trending_down',
                }"
            >
                {{ trending }}
            </i>
            <span
                class="heading mb-0 is-size-6"
                v-bind:class="{
                    'has-text-income': trending === 'trending_up',
                    'has-text-outcome': trending === 'trending_down',
                }"
            >
                {{ header }}
            </span>
        </p>
        <p class="has-text-weight-semibold is-size-3 is-money">
            {{ toMoney(value) }}
        </p>
        <p class="has-text-weight-light mb-0 is-size-6">{{ footer }}</p>
    </div>
</template>


<script>
import { parseToMoney } from "@/utils/currency";

export default {
    name: "CardTotalTax",
    methods: {
        toMoney: parseToMoney,
    },
    props: {
        trending: {
            type: String,
        },
        header: {
            type: String,
        },
        footer: {
            type: String,
        },
        value: {
            type: Number,
        },
    },
};
</script>
